module.exports = __webpack_public_path__ + "img/sl-benfica.3af6fba9.png";